import { Menu } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { NavList } from "./NavList";

/**
 * The same navigation as AppSidebar, as a drawer, below the `lg` breakpoint.
 *
 * Keep the `SheetTrigger`: Radix's close handler preventDefaults the focus restore
 * and focuses its own `triggerRef`, so a button driving `open` by hand leaves Escape
 * dropping focus to <body>. A plain Button rather than `ds/IconAction` because that
 * already has a tooltip trigger inside it, and stacking two Radix triggers is not a
 * pattern used anywhere else here.
 */
export function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label="Open navigation"
          className="lg:hidden"
        >
          <Menu aria-hidden="true" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-64 p-4">
        <SheetHeader className="p-0">
          {/* Radix needs a title for the dialog's name; hidden because the page
              outline has no use for the heading. */}
          <SheetTitle className="sr-only">Navigation</SheetTitle>
        </SheetHeader>
        <nav aria-label="Main">
          <NavList onNavigate={() => setOpen(false)} />
        </nav>
      </SheetContent>
    </Sheet>
  );
}
